import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../elements/list/list";
import { Container } from "../../common/layout/styels";
const Authorisations = (props) => {
  const { t } = useTranslation();
  const [attributes] = useState([
    {
      type: "text",
      placeholder: "organization",
      name: "organization",
      validation: "",
      default: "",
      label: "organization",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "checkbox",
      placeholder: "dashboard",
      name: "dashboard",
      validation: "",
      showItem: "",
      default: "",
      label: "dashboard",
      required: false,
      view: true,
      tag: true,
      add: false,
      update: true,
    },
    {
      type: "checkbox",
      placeholder: "employees",
      name: "employees",
      validation: "",
      showItem: "",
      default: "",
      label: "employees",
      required: false,
      view: true,
      tag: true,
      add: false,
      update: true,
    },
    {
      type: "checkbox",
      placeholder: "team",
      name: "team",
      validation: "",
      showItem: "",
      default: "",
      label: "team",
      required: false,
      view: true,
      tag: true,
      add: false,
      update: true,
    },
    {
      type: "checkbox",
      placeholder: "schedule",
      name: "schedule",
      validation: "",
      showItem: "",
      default: "",
      label: "schedule",
      required: false,
      view: true,
      tag: true,
      add: false,
      update: true,
    },
    {
      type: "checkbox",
      placeholder: "worklog",
      name: "worklog",
      validation: "",
      showItem: "",
      default: "",
      label: "worklog",
      required: false,
      view: true,
      tag: true,
      add: false,
      update: true,
    },
    {
      type: "checkbox",
      placeholder: "leaveRequest",
      name: "leaveRequest",
      validation: "",
      showItem: "",
      default: "",
      label: "leaveRequest",
      required: false,
      view: true,
      tag: true,
      add: false,
      update: true,
    },
    {
      type: "checkbox",
      placeholder: "report",
      name: "report",
      validation: "",
      showItem: "",
      default: "",
      label: "report",
      required: false,
      view: true,
      tag: true,
      add: false,
      update: true,
    },
    {
      type: "checkbox",
      placeholder: "news",
      name: "news",
      validation: "",
      showItem: "",
      default: "",
      label: "news",
      required: false,
      view: true,
      tag: true,
      add: false,
      update: true,
    },
    {
      type: "checkbox",
      placeholder: "settings",
      name: "settings",
      validation: "",
      showItem: "",
      default: "",
      label: "settings",
      required: false,
      view: true,
      tag: true,
      add: false,
      update: true,
    },
    
  ]);

  //to update the page title
  useEffect(() => {
    document.title = `${t("authorisations")} - PersoBase`;
  }, [t]);

  return (
    <Container className="noshadow">
      <ListTable {...props} api={`company`} itemTitle={`organization`} shortName={`authorisations`} addPrivilege={false} delPrivilege={false} updatePrivilege={true} attributes={attributes}></ListTable>
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(Authorisations);
